import { Box } from '@mui/material';
import { createFormConfigData } from '../../../helper/form_builder';
import CreateFormHeaderComponent from './create_form_header';
import FormBuilderComponent from './form_builder';
import FormSettingsComponent from './form_settings';
import PreviewFormComponent from './preview_form';
import { useEffect } from 'react';
import { AppDispatch, RootState } from '../../../redux/store';
import { fetchFormTemplatesThunk, previewRenderFormThunk } from '../../../redux/thunks/form';
import { useDispatch, useSelector } from 'react-redux';

const CreateFormComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { preview, settings, formFields } = useSelector((state: RootState) => state.form);
    useEffect(() => {
        const fetchFormTemplates = async () => {
            try {
                if (preview) {
                    const form_json = JSON.stringify(createFormConfigData(formFields));
                    await dispatch(fetchFormTemplatesThunk()).unwrap();
                    await dispatch(previewRenderFormThunk({
                        template_id: formFields.formTemplateId || 2,
                        form_json,
                        form_title: formFields.formTitle
                    })).unwrap();
                }
            } catch (e) {
                //
            }
        };
        fetchFormTemplates();
    }, [preview]);
    return <Box >
        <CreateFormHeaderComponent />
        {settings ? <FormSettingsComponent /> : preview ? <PreviewFormComponent /> : <FormBuilderComponent />}
    </Box>;
};

export default CreateFormComponent;